const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogisticsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "2.1981 1.7452 95 95.1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -0.3019340083291233, -0.7548310273115497)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.4,28.7l-19.9,6.5c-0.7,0.2-1.2,0.9-1.2,1.7v26.1c0,0.8,0.5,1.4,1.2,1.7l19.9,6.5c0.2,0.1,0.4,0.1,0.5,0.1     c0.2,0,0.4,0,0.6-0.1l19.9-6.5c0.7-0.2,1.2-0.9,1.2-1.7V36.9c0-0.8-0.5-1.4-1.2-1.7l-19.9-6.5C50.2,28.6,49.8,28.6,49.4,28.7z      M48.2,67.2l-16.4-5.4V39.4l6.4,2.1V56c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8V42.6l6.4,2.1V67.2z M68.1,61.8l-6.4,2.1v-9.2     c0-1-0.8-1.8-1.8-1.8c-1,0-1.8,0.8-1.8,1.8v10.3l-6.4,2.1V44.7l16.4-5.4V61.8z M50,41.6l-14.2-4.7L50,32.2l14.3,4.7L50,41.6z",
    style: {
      fill: "rgb(1, 191, 185)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1,38.6c1.1,0,2.1-0.9,2.1-2.1c0-11.7,9-21.3,20.5-22.2v5.2c0,0.7,0.4,1.4,1.1,1.8c0.3,0.2,0.7,0.3,1,0.3     c0.4,0,0.7-0.1,1.1-0.3l12.4-7.5c0.6-0.4,1-1,1-1.8c0-0.7-0.4-1.4-1-1.8L37.8,2.8c-0.6-0.4-1.4-0.4-2.1,0     c-0.7,0.4-1.1,1.1-1.1,1.8v5.6C20.9,11.2,10,22.6,10,36.6C10,37.7,10.9,38.6,12.1,38.6z M38.8,8.2l6.4,3.8l-6.4,3.8V8.2z",
    style: {
      fill: "rgb(1, 191, 185)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6,85.8c-11.7,0-21.3-9-22.2-20.5h5.2c0.7,0,1.4-0.4,1.8-1.1c0.4-0.7,0.4-1.4,0-2.1l-7.5-12.4c-0.8-1.2-2.8-1.2-3.5,0     L2.8,62.2c-0.4,0.6-0.4,1.4,0,2.1c0.4,0.7,1.1,1.1,1.8,1.1h5.6C11.2,79.1,22.6,90,36.6,90c1.1,0,2.1-0.9,2.1-2.1     S37.7,85.8,36.6,85.8z M8.2,61.2l3.8-6.4l3.8,6.4H8.2z",
    style: {
      fill: "rgb(1, 191, 185)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9,61.4c-1.1,0-2.1,0.9-2.1,2.1c0,11.7-9,21.3-20.5,22.2v-5.2c0-0.7-0.4-1.4-1.1-1.8c-0.6-0.4-1.4-0.4-2.1,0     l-12.4,7.5c-0.6,0.4-1,1-1,1.8s0.4,1.4,1,1.8l12.4,7.5c0.3,0.2,0.7,0.3,1.1,0.3c0.4,0,0.7-0.1,1-0.3c0.7-0.4,1.1-1.1,1.1-1.8     v-5.6C79.1,88.8,90,77.4,90,63.4C90,62.3,89.1,61.4,87.9,61.4z M61.2,91.8l-6.4-3.8l6.4-3.8V91.8z",
    style: {
      fill: "rgb(1, 191, 185)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2,35.7c-0.4-0.7-1.1-1.1-1.8-1.1h-5.6C88.8,20.9,77.4,10,63.4,10c-1.1,0-2.1,0.9-2.1,2.1s0.9,2.1,2.1,2.1     c11.7,0,21.3,9,22.2,20.5h-5.2c-0.7,0-1.4,0.4-1.8,1.1c-0.4,0.7-0.4,1.4,0,2.1l7.5,12.4c0.4,0.6,1,1,1.8,1c0.7,0,1.4-0.4,1.8-1     l7.5-12.4C97.6,37.1,97.6,36.3,97.2,35.7z M87.9,45.1l-3.8-6.4h7.7L87.9,45.1z",
    style: {
      fill: "rgb(1, 191, 185)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogisticsIcon);
export default __webpack_public_path__ + "static/media/LogisticsIcon.e49bb3778d6a2f7256d6f9dae9a05e8b.svg";
export { ForwardRef as ReactComponent };